/* pc客户端调用的方法 */
export default class ClientMethod {
  constructor(vm) {
    this.initAnimation()
    this.vm = vm
  }

  initAnimation() { // 上传下载时候的绿色的小箭头
    window.TransTaskAdded = () => {
      window.$toast.simpleShow('已添加到传输列表', 'warn')
    }
  }
}
